import './App.css';
import React, { useState, useRef, useEffect } from 'react';
import { ReactComponent as NotificationIcon } from './svg/notification.svg';
import { ReactComponent as SearchIcon } from './svg/search.svg';
import { ReactComponent as BrandIcon } from './svg/brand.svg';
import { ReactComponent as MenuIcon } from './svg/menu.svg';


const App = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const menuRef = useRef(null);
  const searchRef = useRef(null);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [searchRef, menuRef]);


  return (
    <div className="app">
      <div className="header">

        <div className="menu-container" ref={menuRef}>
          <button className="menu-toggle header-button" id='menu-button' aria-label="Menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <MenuIcon />
          </button>

          <div className={`menu-dropdown ${isMenuOpen ? 'open' : ''}`} style={{ zIndex: 1000, position: 'absolute' }}>
            <ul className="menu-list">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>

        <h3 className={`app-title ${isSearchOpen ? 'closed' : ''}`} > <a href="#home"><BrandIcon id='brand-icon' /></a> App V1</h3>

        <div className="search" ref={searchRef}>

          <button className="search-toggle header-button" id='search-button' aria-label="Search" onClick={() => { setIsSearchOpen(!isSearchOpen); }}>
            <SearchIcon />
          </button>

          <label>          
            <input className={`search-bar ${isSearchOpen ? 'open' : ''}`} id="search" type="search" placeholder="Search..." />
          </label>

          <button className='header-button' id='notification-button'>
            <NotificationIcon />
          </button>

        </div>

      </div>

      <div className="subheader"> Group </div>

      <div className="body-wrapper">
        <div className="label"> Categories </div>
        <div className="categories-wrapper">
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
          <div className="category">Category</div>
        </div>

        <div className="label">Featured</div>

        <div className="featured-content-container">
          <div className="post-wrapper">
            <div>
              <div className="post">
                <img className="thumbnail" src="https://supplement-app-bucket.s3.amazonaws.com/img/supplement-art.png" alt="default"></img>
                <div className="post-preview">
                  <h6 className="post-title">Vitamin B12</h6>
                  <p className="post-intro">Helps keep nerve and blood cells healthy, make DNA and prevent anemia</p>
                  <button className="post-button" href="#" type="pointer">Learn More</button>
                </div>
              </div>
            </div>

            <div>
              <div className="post">
                <img className="thumbnail" src="https://supplement-app-bucket.s3.amazonaws.com/img/supplement-art.png" alt="default"></img>
                <div className="post-preview">
                  <h6 className="post-title">Fish Oil</h6>
                  <p className="post-intro">Omega-3 fatty acids are vital to your heart and brain health</p>
                  <button className="post-button" href="#" type="pointer">Learn More</button>
                </div>
              </div>
            </div>

            <div>
              <div className="post">
                <img className="thumbnail" src="https://supplement-app-bucket.s3.amazonaws.com/img/supplement-art.png" alt="default"></img>
                <div className="post-preview">
                  <h6 className="post-title">Vitamin B12</h6>
                  <p className="post-intro">Helps keep nerve and blood cells healthy, make DNA and prevent anemia</p>
                  <button className="post-button" href="#" type="pointer">Learn More</button>
                </div>
              </div>
            </div>

            <div>
              <div className="post">
                <img className="thumbnail" src="https://supplement-app-bucket.s3.amazonaws.com/img/supplement-art.png" alt="default"></img>
                <div className="post-preview">
                  <h6 className="post-title">Fish Oil</h6>
                  <p className="post-intro">Omega-3 fatty acids are vital to your heart and brain health</p>
                  <button className="post-button" href="#" type="pointer">Learn More</button>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default App;